import { render, staticRenderFns } from "./Contador.vue?vue&type=template&id=f28c9c38&scoped=true&"
import script from "./Contador.vue?vue&type=script&lang=js&"
export * from "./Contador.vue?vue&type=script&lang=js&"
import style0 from "./Contador.vue?vue&type=style&index=0&id=f28c9c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28c9c38",
  null
  
)

export default component.exports